import styled from "@emotion/styled";

export const MainWrap = styled.main`

    width: 100vw; padding-top: 90px;

    @media screen and (max-width: 992px) {
        padding-top: 50px;
    }
`;